import { createFileRoute } from '@tanstack/react-router'
import { OverviewPage } from '@/features/overview/ui/overview-page'
import { PageLayout } from '@/components/page-layout'

export const Route = createFileRoute('/_authenticated/')({
	component: () => {
		return (
			<PageLayout data-id='overview-page'>
				<OverviewPage />
			</PageLayout>
		)
	},
})
